import { getParameterByName } from '../utils/toSearchParams';
import { defined } from '../utils/variableEvaluation';
import { updateIntl } from 'react-intl-redux';

export function sideActions({ dispatch, getState }) {
  return (next) => (action) => {
    if (action.type === '@@router/LOCATION_CHANGE') {
      const langParam = getParameterByName('lang');
      let langCode = getState().intl.locale;

      if (defined(langParam) && langParam !== langCode) {
        let languages = ['en', 'fr', 'it', 'de'];

        if (languages.indexOf(langCode) >= 0) {
          dispatch(
            updateIntl({
              locale: langParam,
              messages: getState().locales[langParam],
            }),
          );
        } else {
          dispatch(
            updateIntl({
              locale: langParam,
              messages: getState().locales['de'],
            }),
          );
          console.error(`${langParam} is not supported language`);
        }
      }
    }
    return next(action);
  };
}
